import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { BaseApiResponse } from '../../models/api/api.model';
import { environment } from '../../../../environments/environment';
import {
  CreateOrganizationRequest,
  DeleteOrganizationRequest,
  Organization,
  OrganizationListData,
  UpdateOrganizationRequest,
  OrganizationAvatarUploadResponse,
  GetAvatarResponse,
  DeleteAvatarResponse,
} from '../../models/organization/organization.model';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class OrganizationService {
  constructor(private apiService: ApiService) { }

  private apiURL = `${environment.apiLocations.organization}/organizations`;

  private getOrganizationByIdURL = `${this.apiURL}/getOrganizationById`;
  private getListOrganizationURL = `${this.apiURL}/getListOrganization`;
  private getAllOrganizationURL = `${this.apiURL}/getAllOrganization`;
  private updateOrganizationURL = `${this.apiURL}/updateOrganization`;
  private deleteOrganizationURL = `${this.apiURL}/deleteOrganization`;
  private createOrganizationURL = `${this.apiURL}/createOrganization`;
  private uploadAvatarURL = `${this.apiURL}/upload-avatar`;
  private getAvatarURL = `${this.apiURL}/get-avatar`;
  private deleteAvatarURL = `${this.apiURL}/delete-avatar`;

  getAllOrganizationItems(): Observable<Organization[]> {
    return this.apiService.get<any>(this.getAllOrganizationURL).pipe(
      map((res: any) => {
        console.log('RAW getAllOrganization response:', res);

        return res?.data ?? [];
      })
    );
  }

  getOrganizationById(id: string): Observable<BaseApiResponse<Organization>> {
    return this.apiService.get<Organization>(
      `${this.getOrganizationByIdURL}?Id=${id}`
    );
  }

  getListOrganization(
    pageIndex: number = 0,
    pageSize: number = 10,
    name?: string,
    customerCode?: string,
    email?: string,
    sortBy?: string | null,
    sortDirection?: string | null
  ): Observable<BaseApiResponse<OrganizationListData>> {
    let url = `${this.getListOrganizationURL}?PageIndex=${pageIndex}&PageSize=${pageSize}`;

    if (name) {
      url += `&Name=${encodeURIComponent(name)}`;
    }
    if (customerCode) {
      url += `&CustomerCode=${encodeURIComponent(customerCode)}`;
    }
    if (email) {
      url += `&Email=${encodeURIComponent(email)}`;
    }

    if (sortBy) {
      url += `&SortBy=${sortBy}`;
    }
    if (sortDirection) {
      url += `&SortDirection=${sortDirection}`;
    }

    return this.apiService.get<OrganizationListData>(url);
  }

  getAllOrganization(): Observable<BaseApiResponse<OrganizationListData>> {
    return this.apiService.get<OrganizationListData>(
      this.getAllOrganizationURL
    );
  }
  createOrganization(
    request: CreateOrganizationRequest
  ): Observable<BaseApiResponse<OrganizationListData>> {
    return this.apiService.post<OrganizationListData>(
      this.createOrganizationURL,
      request
    );
  }

  updateOrganization(
    request: UpdateOrganizationRequest
  ): Observable<BaseApiResponse<OrganizationListData>> {
    return this.apiService.post<OrganizationListData>(
      this.updateOrganizationURL,
      request
    );
  }

  deleteOrganization(id: string): Observable<BaseApiResponse<any>> {
    const request: DeleteOrganizationRequest = { id: id };
    return this.apiService.post<any>(this.deleteOrganizationURL, request);
  }

  uploadAvatar(
    formData: FormData
  ): Observable<BaseApiResponse<OrganizationAvatarUploadResponse>> {
    return new Observable((observer) => {
      this.apiService.post(this.uploadAvatarURL, formData).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }

  getAvatar(organizationId: string): Observable<BaseApiResponse<GetAvatarResponse>> {
    return this.apiService.get<GetAvatarResponse>(
      `${this.getAvatarURL}/${organizationId}`
    );
  }

  deleteAvatar(organizationId: string): Observable<BaseApiResponse<DeleteAvatarResponse>> {
    return new Observable((observer) => {
      this.apiService.post(this.deleteAvatarURL, { organizationId }).subscribe({
        next: (res) => {
          observer.next(res);
          observer.complete();
        },
        error: (err) => {
          observer.error(err);
        },
      });
    });
  }
}
